document.addEventListener("alpine:init", () => {
    Alpine.data("pressByYear", () => ({
        year: null,
        isFixed: false,
        positionTop: 0,
        lastScrollTop: 0,
        filters: null,
        init() {
            this.filters = this.$refs.stickyFilters;

            pegasus.onResizeFinished(() => {
                setTimeout(() => {
                    this.positionTop = pegasus.getElemOffset(
                        this.$refs.stickyFilters
                    );
                }, 200);
            }, true);
        },
        fix() {
            if (this.isFixed) {
                if (window.scrollY <= this.positionTop.top) {
                    this.isFixed = false;
                }
            } else {
                if (window.scrollY >= this.positionTop.top) {
                    this.isFixed = true;
                }
            }
        },
    }));
});
